$(document).ready(function () {
$('.mybannerslider').on('init', function (event, slick) {
$('.slick-current .home_header-b').addClass('animate-right');
});

$('.mybannerslider').on('afterChange', function (event, slick, currentSlide) {
$('.home_header-b').removeClass('animate-right');
var $currentSlide = $('.slick-slide[data-slick-index="' + currentSlide + '"]');
var $target = $currentSlide.find('.home_header-b');
void $target[0].offsetWidth;
$target.addClass('animate-right');
});

$('.mybannerslider').slick({
slidesToScroll: 1,
arrows: false,
dots: true,
vertical: true,
verticalSwiping: true,
autoplay: true,
autoplaySpeed: 4000,
speed: 1000,
cssEase: 'linear',
responsive: [{
breakpoint: 768,
settings: {
verticalSwiping: false
}
}]
});
});

/****** PRISM: GA4 begin_checkout — Ajax Cart Drawer ******/
document.addEventListener('DOMContentLoaded', function () {
var checkoutBtn = document.getElementById('ajaxcart-checkout');
if (!checkoutBtn) return;

checkoutBtn.addEventListener('click', function () {
if (typeof gtag !== 'function') return;

fetch('/cart.js')
.then(function (res) { return res.json(); })
.then(function (cart) {
var items = (cart.items || []).map(function (item) {
return {
item_id: item.product_id ? String(item.product_id) : item.sku,
item_name: item.product_title || item.title,
item_variant: item.variant_title || '',
price: (item.price / 100).toFixed(2),
quantity: item.quantity
};
});

gtag('event', 'begin_checkout', {
currency: cart.currency || 'CAD',
value: (cart.total_price / 100).toFixed(2),
items: items
});
})
.catch(function () { /* fail silently */ });
});
});
/****** END PRISM: begin_checkout ******/

//sidebar filter js
$(document).ready(function () {
$('.sidebar-filter-option').on('click', '[data-toggle="collapse"]', function (e) {
e.preventDefault();
var targetId = $(this).attr('href');
var $target = $(targetId);
$('.sidebar-filter-option [data-toggle="collapse"]').each(function () {
var otherId = $(this).attr('href');
if (otherId !== targetId) {
$(otherId).slideUp(200).removeClass('open');
}
});
if ($target.length) {
$target.slideToggle(200).toggleClass('open');
}
});

$(".shop-sidebar .tab-title").on("click", function () {
const isActive = $(this).hasClass("active");
$(".shop-sidebar .tab-title").removeClass("active");
if (!isActive) {
$(this).addClass("active");
}
});
});

/************color text capitalize ******************/
document.querySelectorAll('.color .filter-name').forEach(function (el) {
el.textContent = el.textContent.toLowerCase().replace(/\b\w/g, function (char) {
return char.toUpperCase();
});
});

/******************(Size guide setup)*********************/
$(document).ready(function () {
let hasNonNumeric = false;
$('.ot-size').each(function () {
const text = $(this).text().trim();
if (/[a-zA-Z]/.test(text)) {
hasNonNumeric = true;
return false;
}
});

if (hasNonNumeric) {
$('.unit-switcher').remove();
} else {
$('.unit-switcher').on('click', function () {
$('.unit-switcher__toggle').toggleClass('toggled');
$('.ot-size').each(function () {
const isToggled = $('.unit-switcher__toggle').hasClass('toggled');
let $label = $(this);
let cm = $label.data('cm');
if (!cm) {
cm = $label.text().trim();
$label.data('cm', cm);
}
if (isToggled) {
const inches = (parseFloat(cm) * 0.393701).toFixed(2);
$label.text(inches);
} else {
$label.text(cm);
}
});
});
}
});

/******************Header menu active js**************************/
$(document).ready(function () {
var currentPath = window.location.pathname.replace(/\/$/, '');
$('.menu-link').each(function () {
var parent = $(this);
var isActive = false;
parent.find('ul.menu-dropdown a, ul.shopsupmenu-dropdown a').each(function () {
var childHref = $(this).attr('href');
if (!childHref) return;
var linkPath = childHref.replace(/^https?:\/\/[^\/]+/, '').replace(/\/$/, '');
if (currentPath === linkPath) {
isActive = true;
$(this).closest('.shop-title').addClass('list-menu__item--active');
return false;
}
});
if (isActive) {
parent.addClass('list-menu__item--active');
}
var parentLink = parent.children('a.link-title').attr('href');
if (parentLink) {
var parentPath = parentLink.replace(/^https?:\/\/[^\/]+/, '').replace(/\/$/, '');
if (currentPath === parentPath) {
parent.addClass('list-menu__item--active');
}
}
});
});

/*************Product details page tab************/
$(document).ready(function () {
$('.product-accordions details').first().attr('open', true);
});

function updateHeaderIndicators() {
var wishlistCount = parseInt($('.wishlist-counter').text(), 10);
if (wishlistCount > 0) {
$('.wishlist-wrap').removeClass('hide').addClass('active');
} else {
$('.wishlist-wrap').addClass('hide').removeClass('active');
}
var cartCount = parseInt($('.ajax-cart-count span[aria-hidden="true"]').text(), 10);
if (cartCount > 0) {
$('.cart-wrap').show();
} else {
$('.cart-wrap').hide();
}
}

$(document).ready(function () {
updateHeaderIndicators();
});

//Redirect /collections to /collections/all-products
$(document).ready(function () {
var path = window.location.pathname;
if (path === '/collections' || path === '/collections/') {
window.location.href = '/collections/all-products';
}
});

//home page video js
document.addEventListener("DOMContentLoaded", function () {
const video = document.querySelector("video");
if (video) {
video.play().catch(() => {
document.addEventListener("click", () => video.play());
});
}
});

//collection filter button and scroll page js
$(document).ready(function () {
$(document).on('click', '.product-filter', function (e) {
e.preventDefault();
$('body').addClass('product-filter-overlay');
});
$(document).on('click', '.close-filter-sidebar', function (e) {
e.preventDefault();
$('body').removeClass('product-filter-overlay');
var $btn = $('#button-filter-pt');
if ($btn.length) {
$btn.trigger('click');
}
});
});

//filter open hide js
document.addEventListener('click', function (e) {
if (e.target.closest('.shop-sidebar')) return;
document.querySelectorAll('.collapse.flt-ele.open').forEach(function (collapseFilter) {
collapseFilter.classList.remove('open');
collapseFilter.style.display = 'none';
});
});